import React, { useRef, useState } from 'react';
import { IonButton, IonButtons, IonIcon, IonModal, IonToolbar } from '@ionic/react';
import { chevronDown } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { SelectNative } from './ui/select-native';

interface SexPickerProps {
  defaultValue?: number;
  onChange?: (value: number) => void;
  className?: string;
  placeholder?: string;
}

type SexOption = {
  value: number;
  label: string;
};

const sexOptions: SexOption[] = [
  { value: 1, label: 'man' },
  { value: 2, label: 'woman' },
];

const SexPicker: React.FC<SexPickerProps> = ({
  defaultValue,
  onChange = () => { },
  className,
}) => {
  const [selectedSex, setSelectedSex] = useState<number>(defaultValue || 0);
  const { t } = useTranslation();

  const handleSelect = (value: number) => {
    setSelectedSex(value);
    onChange(value);
  };

  return (
    <SelectNative
      value={selectedSex.toString()}
      onChange={(e) => handleSelect(Number(e.target.value))}
      className={`w-full opacity-100 max-w-64 border border-input bg-inherit rounded-lg text-foreground ${className}`}
    >
      <option value="0" disabled>--</option>
      {sexOptions.map((option) => (
        <option key={option.value} value={option.value.toString()}>
          {t(option.label)}
        </option>
      ))}
    </SelectNative>
  );
};

export default SexPicker;
